/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/loupe'
export default icon
